var render = function render(){var _vm=this,_c=_vm._self._c;return _c('label-value',{attrs:{"label":_vm.$gettext('activity')}},[_c('icon-event-activity',{staticClass:"is-size-3 has-text-secondary",attrs:{"event-activity":_vm.document.event_activity}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }